import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vueWechatTitle from 'vue-wechat-title'
// import Vant from 'vant'
// import 'vant/lib/index.css';
// import Mint from 'mint-ui'
// import 'mint-ui/lib/style.css'
// import './assets/css/my-mint.styl'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAMap from 'vue-amap'
import OSS from 'ali-oss' // 引入ali-oss

// import vueTap from 'v-tap';
// import vueTap from ''



// 上传文件配置
let client = new OSS({
	region: 'oss-cn-shanghai',
	accessKeyId: 'LTAIHxGvbfNPMhmK',
	accessKeySecret: 'OQ4OGv5JVUvYuzp1kOnjzX5hl4SJY2',
	bucket: 'dbshs',
})

Vue.prototype.$client = client // 注册全局变量

axios.defaults.baseURL = process.env.VUE_APP_BASE_API
Vue.config.productionTip = false

Vue.use(vueWechatTitle)
// Vue.use(Vant)
// Vue.use(Mint)
Vue.use(ElementUI)
Vue.use(VueAMap)

Vue.prototype.$VueAMap = VueAMap
VueAMap.initAMapApiLoader({
	key: '791dad51db41193ce9be99c9a2643383',
	plugin: ['Geolocation', 'Autocomplete', 'PlaceSearch', 'Scale', 'OverView', 'ToolBar', 'MapType', 'PolyEditor', 'CircleEditor', ],
	v: '1.4.4'
})

new Vue({
	router,
  render: h => h(App),
}).$mount('#app')

